import { defineStore } from 'pinia'
import Network from '@/Network'
import { CreatePosition } from '@/Network/Types/Requests/PositionRequests'
import {
  ListPositionsResponse,
  PositionResponse
} from '@/Network/Types/Responses/PositionResponses'

export type PositionState = {
  positions: ListPositionsResponse | undefined
  listPositions: PositionResponse[]
}

export const usePositionStore = defineStore('position', {
  state: (): PositionState => ({
    positions: undefined,
    listPositions: []
  }),
  actions: {
    async getAllPositions(): Promise<void> {
      const data = await Network.position.list()
      this.positions = data
      this.listPositions = this.positions.data
    },
    async create(payload: CreatePosition) {
      await Network.position.create(payload)
    },
    async remove(positionId: number): Promise<void> {
      // Chamava `Network.schedule.remove(positionId)` — excluía a ESCALA cujo id
      // coincidisse com o id da posição. Sem callers hoje, mas a mensagem de erro
      // específica desta action só faz sentido no endpoint certo.
      await Network.position.remove(positionId)
    },
    async update({
      positionId,
      payload
    }: {
      positionId: number
      payload: CreatePosition
    }): Promise<void> {
      await Network.position.update(positionId, payload)
    },
    async getByScheduleId(scheduleId: number): Promise<void> {
      const response = await Network.position.getByScheduleId(scheduleId)
      this.listPositions = response.data
    },

    async setPositionsBySchedules(scheduleIds: number[] | null) {
      if (!scheduleIds?.length) {
        this.listPositions = []
        return
      }
      await this.getAllPositions()
      const positions =
        this.positions?.data?.filter((p) => scheduleIds.includes(p?.schedule?.id)) || []
      this.listPositions = positions
    }
  }
})
